import clsx from 'clsx'
import type {CSSProperties} from 'react'
import {Link} from 'react-router-dom'

interface Props {
    url: string
    height?: number
    label?: string | null
    className?: string
    labelClassName?: string
    alt?: string
    // Короткий вариант картинки в виде одной буквы.
    // При short === true, label = false всегда.
    short?: boolean
    fullLogoUrl?: string
    fullLogoClassName?: string
    fullLogoWrapperStyle?: CSSProperties
    fullLogoStyle?: CSSProperties
    logoLabelStyle?: CSSProperties
}

// Логотип приложения с подписью для шапки и подвала сайта.
export function LogoWithLabel(props: Props) {

    const {
        url,
        height,
        label,
        className,
        labelClassName,
        alt,
        short,
        fullLogoUrl,
        fullLogoWrapperStyle,
        fullLogoStyle,
        fullLogoClassName,
        logoLabelStyle,
    } = props

    if (short) {
        return (
            <Link
                to={url}
                className={clsx(
                    'logo-with-label logo-with-label-short',
                    className
                )}
            >
                <img
                    src="/img/dotoku-short.svg"
                    alt={alt}
                    height={height}
                />
            </Link>
        )
    }

    const img = fullLogoUrl ? (
        <span
            style={fullLogoWrapperStyle}
            className="d-block overflow-visible"
        >
            <img
                src={fullLogoUrl}
                alt={alt}
                height={height}
                style={fullLogoStyle}
            />
        </span>
    ) : (
        <img
            src="/img/dotoku.svg?v=20260930"
            alt={alt}
            height={height}
        />
    )

    return (
        <Link
            to={url}
            className={clsx(
                'logo-with-label',
                className,
                fullLogoUrl ? fullLogoClassName : ''
            )}
        >
            {img}
            {label && (
                <span
                    className={clsx('d-block logo-label', labelClassName)}
                    style={logoLabelStyle}
                >
                    {label}
                </span>
            )}
        </Link>
    )
}
